export const STATUS_OPTIONS = [
    "To Start",
    "Doing",
    "On hold",
    "Task Complete",
    "Documented",
    "Closed w Review",
  ];

  // Category -> Types. Category is mandatory and lives on the Task; Type is
  // optional, lives on each Action Item, and is constrained by the parent
  // task's Category. A task is treated as a meeting on the Calendar View when
  // category === 'Communication' && any of its action items has a MEETING_TYPE.
  export const CATEGORY_TYPE_MAP = {
    Build: ["Design", "Implementation", "Documentation", "Test", "Deployment"],
    "Tech Support": ["Bug", "Test/QA"],
    "Money and Finance": ["Pay", "Bookkeeping", "Compliance"],
    Communication: ["Email", "WhatsApp", "Phone Call", "Face to Face", "Online Meet"],
  };

  export const CATEGORY_OPTIONS = Object.keys(CATEGORY_TYPE_MAP);

  export const DEFAULT_CATEGORY = "Build";

  // Task class: a coarse bucket for the kind of work a task represents.
  export const CLASS_OPTIONS = ["Core", "Errand", "Support", "Maintenance"];

  /**
   * Action-item Types valid under a given task category. When `currentType` is
   * supplied and is not part of the category's set (e.g. a legacy value on an
   * existing item), it is appended so an edit form can still display it.
   */
  export const typesForCategory = (category, currentType) => {
    const base = CATEGORY_TYPE_MAP[category] || [];
    if (currentType && !base.includes(currentType)) return [...base, currentType];
    return base;
  };

  // A task counts as a meeting (for the Calendar View) under these values: the
  // Communication category plus an action item whose type implies people
  // meeting live.
  export const MEETING_CATEGORY = "Communication";
  export const MEETING_TYPES = ["Online Meet", "Face to Face"];

  /**
   * True when a task should be shown as a meeting on the Calendar View: it is a
   * Communication task and at least one of its live action items is a meeting.
   *
   * `actionItems` may be undefined where they haven't been loaded, in which
   * case the task is not (yet) treated as a meeting.
   */
  export const isMeetingTask = (category, actionItems) =>
    category === MEETING_CATEGORY &&
    (actionItems || []).some(
      (item) => !item?.is_archived && MEETING_TYPES.includes(item?.type)
    );